import { useTranslation } from 'react-i18next'
import { MapView } from '@/components/MapView'

export function MapPage() {
  const { t } = useTranslation()
  return (
    <section className="mx-auto max-w-6xl px-4 py-6">
      <h1 className="mb-4 text-2xl font-semibold">{t('map.title')}</h1>
      <div className="overflow-hidden rounded-xl border border-slate-200 bg-white shadow-sm">
        <MapView />
      </div>
    </section>
  )
}
